import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Notification from './Notification';
import LazyImage from '../../hocs/Lazy/LazyImage';
import { purifier, addEvent, removeEvent, hasClass, addClass, removeClass } from '../../utils/dom';
import { imageSizeTranslation } from '../../utils/image';
import { changeLanguage, goToPage, changeDevice, clientInit, retrieveListing } from '../../actions/environment';
import { translate, prefix } from '../../utils/locale';
import s from './Header.scss';

class Header extends Component {
	constructor(props) {
		super(props);

		this.state = {
			location: false,
			grid: false,
			menuOpen: false,
			expandedSection: ['index'],
		};

		this.headerElement = React.createRef();
		this.summaryElement = React.createRef();
	}

	componentDidMount() {
		const $html = document.querySelector('html');
		let currentWidth = window.innerWidth <= 600;

		this.props.clientInit();

		this.props.changeDevice(currentWidth);

		// Load in other articles
		this.props.retrieveListing('listing/page').then(() => addClass($html, 'u_loaded')).catch();

		// Wait for page to be rendered with all relevant elements.
		const initiateSiteListeners = () => {
			if (!this.headerElement) {
				setTimeout(initiateSiteListeners, 200);
			}

			const resizeEvent = () => {
				const updatedWidth = window.innerWidth <= 750;

				// Switch between mobile and desktop.
				if (currentWidth !== updatedWidth) {
					this.props.changeDevice(updatedWidth);
					currentWidth = updatedWidth;
				}
			};

			addEvent(window, 'resize.logoHeader', () => {
				window.requestAnimationFrame(resizeEvent);
			});
		};

		initiateSiteListeners();

		if ('ontouchstart' in document.documentElement) {
			removeClass($html, 'no-touchevents');
			addClass($html, 'touchevents');
		}

		if (hasClass($html, 'no-touchevents')) {
			addEvent(window, 'touchstart.touchTest', () => {
				removeClass($html, 'no-touchevents');
				addClass($html, 'touchevents');
				removeEvent(window, 'touchstart.touchTest');
			});
		}

		addEvent(document.querySelector('body'), 'click.linkCapture', (e) => {
			const $link = e.target.closest('a');

			if ($link && hasClass($link, 'linkCapture') && !/(http|mailto|tel)/.test($link.getAttribute('href'))) {
				e.preventDefault();
				this.props.goToPage(e.target.getAttribute('href'));
			}
		});

		addEvent(window, 'keydown.general', (e) => {
			if (e.key === 'Escape') {
				if (this.state.location === true) this.setState({ location: false });
				if (this.state.grid) this.setState({ grid: false });
			} else if (e.shiftKey && e.ctrlKey && e.key === 'A') {
				// ctrl + shift + a = Toggle grid
				this.setState((prevState) => ({ grid: !prevState.grid }));
			}
		});
	}

	componentDidUpdate() {
		const $html = document.querySelector('html');

		if (!hasClass($html, 'u_mounted') && this.props.location.type === 'START') {
			setTimeout(() => {
				addClass($html, 'u_mounted');
			}, 2e2);
		}
	}

	componentWillUnmount() {
		removeEvent(document.querySelector('body'), 'click.cartClose');
		removeEvent(window, 'keydown.general');
		removeEvent(window, 'resize.logoHeader');
	}

	openLocation = (e) => {
		e.preventDefault();

		this.setState((prevState) => ({ location: !prevState.location }));
	}

	changeLanguage = (e) => {
		const changeTo = e.currentTarget.dataset.language;
		this.props.changeLanguage(changeTo);
		this.setState({
			location: false,
		});
	}

	openMobileMenuHandler = (e) => {
		e.preventDefault();

		this.setState((prevState) => {
			if (!prevState.menuOpen) {
				addClass(document.body, 'is_menuOpen');
				setTimeout(() => {
					addClass(document.body, 'is_menuOpen__loaded');
				}, 50);
			}
			if (prevState.menuOpen) removeClass(document.body, ['is_menuOpen', 'is_menuOpen__loaded']);

			return { menuOpen: !prevState.menuOpen };
		});
	}

	closeMobileMenuHandler = () => {
		removeClass(document.body, ['is_menuOpen', 'is_menuOpen__loaded']);
		this.setState({ menuOpen: false });
	}

	expandMenuSection = (e) => {
		e.preventDefault();
		const section = e.currentTarget.getAttribute('href').replace('#expand-', '');

		this.setState((prevState) => {
			const index = prevState.expandedSection.indexOf(section);
			if (index !== -1) {
				return { expandedSection: [...prevState.expandedSection.slice(0, index), ...prevState.expandedSection.slice(index + 1)] };
			}
			return { expandedSection: [...prevState.expandedSection.slice(0), section] };
		});
	}

	render() {
		const { setup, properties, header = {}, location } = this.props;
		const { grid } = this.state;
		if (properties.siteInitiated === false || properties.siteClosed === true) return null;

		return (
			<>
				{ header.campaign && <Notification type="campaign" content={header.campaign} setup={setup} /> }
				<header className={s.header} ref={this.headerElement}>
					<div className={s.header_fixedContainer}>
						<Link className={s.header_fixedContainer_logo} to={prefix(setup, '/')}>
							{ header.logo }
						</Link>
					</div>
					<div className={s.header_intro}>
						{
							location.type === 'INDEXES' ? (
								<div className={s.header_intro_text} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, header.indexIntro)) }} />
							) : (
								<div className={s.header_intro_text} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, header.intro)) }} />
							)
						}
						{ location.type !== 'INDEXES' && <LazyImage {...imageSizeTranslation('4', header.stamp, false)} className={[s.header_intro_stamp]} width="56" height="72" /> }
					</div>
				</header>
				{ grid ? <div className={s.grid}><div /></div> : null }
			</>
		);
	}
}

const mapState = ({ environment, location, pageData }) => {
	const { properties, index, setup, header } = environment;
	return { properties, index, setup, header, location, pageData };
};

export default hot(module)(connect(mapState, {
	changeLanguage,
	goToPage,
	changeDevice,
	clientInit,
	retrieveListing,
})(Header));
